import '../../table.less';
import './inputsTable.less';

// import { CoreHelper, LoggerHelper } from '@helpers';
// import WithCoreProps from '../../../../../hocs/withCoreProps';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { TableRow } from '../../../tableRow';
import { TableAppearance, Row, ColType, TableColumn } from '../../types';
import { TableRowAppearances } from '../../../tableRow/types';
import { CoreHelper, TranslationProps, WithCoreProps } from 'ff-shared-components-core';
import { InputsRowChangeState, RadioInputData, InputsRowCellValue } from '../../../tableRow/tableRowModules';
// import { TranslationProps } from '@i18n';

export interface InputsTableProps {
	appearance?: TableAppearance;
	/**sets the header values */
	headers?: string[];
	/**sets the row values */
	rows?: Row[];
	/**sets an array of widths to render the table, different columns can have different widths */
	columnsWidth?: ColType[];
	/**Sets a checkbox prefix*/
	withCheckbox?: boolean;
	/**Sets a empty column at the end of table*/
	withEmptySpaceSuffix?: boolean;
	/**Sets a suffix for the table row */
	withSuffix?: boolean;
	/**Sets an image  prefix for the row */
	rowImage?: string;
	/**Sets an image prefix for the table row */
	withImage?: boolean;
	/**set a base path to redirect on more details click */
	pathToRedirect?: string;
	/**Set the checkbox check*/
	isCheckboxChecked?: boolean;
	/**Sets a message in case there is no data to show */
	noDataMessage?: string;
	/**flag for error message */
	hasError?: boolean;
	/**Sets an error message in case something went wrong*/
	errorMessage?: string;
	/** serves the purpose of catching the current selected row */
	// onChange?: (items: Row[]) => void;
	/** serves the purpose of catching the current selected row */
	onRowsChange?: (items: Row[]) => void;
	/**Sets an event to be handled on details click */
	onDetailsClick?: (row?: any) => void;
}

type Props = InputsTableProps & RouteComponentProps & TranslationProps;

class InputsTableComponent extends React.PureComponent<Props> {
	selectedRows: Row[] = [];

	public constructor(props: Props) {
		super(props);
		const { rows } = this.props;

		rows &&
			rows.forEach(r => {
				const selectedRowValue = (r.columns as TableColumn[]).find(c => (c.value as InputsRowCellValue).checked)
					?.value;

				if (selectedRowValue !== undefined) {
					const newSelectedRow: Row = {
						id: r.id,
						columns: [
							{
								value: selectedRowValue,
							},
						],
					};

					this.selectedRows.push(newSelectedRow);
				}
			});
	}

	// eslint-disable-next-line sonarjs/cognitive-complexity
	render(): React.ReactNode {
		const {
			headers,
			rows,
			withCheckbox,
			withImage,
			pathToRedirect,
			withSuffix,
			withEmptySpaceSuffix,
			columnsWidth,
			t,
			noDataMessage = t<string>('table.noData'),
			errorMessage,
			hasError,
			onDetailsClick,
		} = this.props;

		return (
			<>
				<div className="it-table-responsive table-appearance-inputs">
					{headers &&
						headers.map(
							(h: string, index: number): JSX.Element => (
								<div
									key={CoreHelper.guid() || index}
									className={`it-table-cell it-table-cell-header${
										index === 0 ? ' cell-alignLeft' : ' cell-alignCenter'
									}`}
								>
									<span>{h}</span>
								</div>
							)
						)}

					{rows && rows.length !== 0
						? rows.map(
								(row: Row, index: number): JSX.Element => (
									<TableRow
										columnsWidth={columnsWidth}
										withSuffix={withSuffix}
										withEmptySpaceSuffix={withEmptySpaceSuffix}
										rowId={row.id}
										row={row}
										key={CoreHelper.guid() || index}
										withImage={withImage}
										rowImage={row.image}
										columns={row.columns}
										isBold={row.isBold}
										handleRowChange={this.handleRowChange}
										appearance={TableRowAppearances.inputsRow}
									></TableRow>
								)
						  )
						: null}
				</div>
				{hasError && errorMessage ? (
					<div className="input-error-text">
						<span>{errorMessage}</span>
					</div>
				) : (
					undefined
				)}
			</>
		);
	}

	private handleRowChange = (rowState: InputsRowChangeState): void => {
		const { onRowsChange: onTableChange, rows } = this.props;

		const isSelectedNewRow = rowState.inputsState.selectedId !== undefined;

		const selectedRowIndex = this.selectedRows.findIndex(s => s.id === rowState.rowId);
		if (selectedRowIndex > -1) {
			if (isSelectedNewRow) {
				this.selectedRows[selectedRowIndex].columns = [
					{
						value: { radioButtonValue: rowState.inputsState.selectedId },
					},
				];
			} else {
				this.selectedRows.splice(selectedRowIndex, 1);
			}
		} else {
			if (isSelectedNewRow) {
				const newSelectedRow: Row = {
					id: rowState.rowId,
					columns: [
						// {
						// 	value: rowState.inputsState.selectedId,
						// },
						{
							value: { radioButtonValue: rowState.inputsState.selectedId },
						},
					],
				};

				this.selectedRows.push(newSelectedRow);
			}
		}

		onTableChange && onTableChange(this.selectedRows);
	};

	private createTableChangeData = (rowState: InputsRowChangeState): TableChangeData => {
		return {
			[rowState.rowId]: rowState.inputsState,
		};
	};

	// private readonly handleOnClick = (selectedRow: Row): void => {
	// 	const { onChange } = this.props;
	// 	if (this.selectedRows.find(s => s.id === selectedRow.id)) {
	// 		this.selectedRows.splice(
	// 			this.selectedRows.findIndex(x => x === selectedRow),
	// 			1
	// 		);
	// 	} else {
	// 		selectedRow.isSelected = true;

	// 		this.selectedRows.push(selectedRow);
	// 	}

	// 	onChange && onChange(this.selectedRows);
	// 	LoggerHelper.log('Inputs table > selected rows', this.selectedRows);
	// };
}

export interface TableChangeData {
	[key: string]: RadioInputData;
	// id: string;
	// checked: boolean;
}

export const InputsTable = WithCoreProps<InputsTableProps>(withRouter(InputsTableComponent));
